import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { WebSocketProvider } from "./lib/ws-context";
import { loadConfig } from "./lib/config";
import "./lib/i18n";
import "./index.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

loadConfig().finally(() => {
  root.render(
    <StrictMode>
      <BrowserRouter>
        <WebSocketProvider>
          <App />
        </WebSocketProvider>
      </BrowserRouter>
    </StrictMode>,
  );
});
